import { storage, settings } from './storage.js';
import { catalog } from './catalog.js';
import { device } from './device.js';
import { i18n } from './i18n.js';

/** `__STANDALONE__` lo fija esbuild al compilar la app independiente; en la web y en las pruebas no existe. */
const STANDALONE = typeof __STANDALONE__ !== 'undefined' && !!__STANDALONE__;

/* Configuración completa de la app en un JSON, para decidir los ajustes por defecto que tendrá una persona al empezar:
   todos los ajustes (vistas, aspecto, reproducción…), los filtros elegidos en cada sección y el orden propio de hileras y canales.
   NO lleva nada personal ni secreto: claves de TMDB/OMDb/OpenSubtitles, direcciones de servidor o proxy, PIN y categorías del control
   parental, proveedores, licencias ni cuentas. */

export const FORMAT = 'filoteca-config';
export const FORMAT_VERSION = 1;

/** Ajustes que no se exportan por ser secretos o propios de un aparato. */
const SKIP = /(token|secret|pass|^pin|pinhash|key$|^osUser$|^serverUrl$|^proxyUrl$)/i;
const stripUpdated = (o) => {
    const out = {};
    Object.keys(o || {}).forEach((k) => { if (k !== 'updated') out[k] = o[k]; });
    return out;
};

/** Quita lo secreto y lo propio de cada aparato (también dentro del control parental, del que solo queda si está activo). */
export function cleanSettings(all) {
    const out = {};
    const skipped = [];
    Object.keys(all || {}).sort().forEach((k) => {
        if (k === 'parental') { out.parental = { enabled: !!(all.parental && all.parental.enabled) }; skipped.push('parental.pinHash', 'parental.categories'); return; }
        if (SKIP.test(k)) { skipped.push(k); return; }
        out[k] = all[k];
    });
    return { settings: out, skipped };
}

function perUser(key) {
    const all = storage.get(key, {}) || {};
    const me = catalog.userKey || '';
    const others = {};
    Object.keys(all).forEach((u) => { if (u !== me) others[u] = stripUpdated(all[u]); });
    return { user: me, current: stripUpdated(all[me]), others };
}

/** El JSON de la configuración de este aparato. `appVersion`: la versión de la app. */
export function buildConfigExport({ appVersion = '' } = {}) {
    const { settings: current, skipped } = cleanSettings(Object.assign({}, settings.all()));
    const { settings: defaults } = cleanSettings(settings.defaults());
    return {
        format: FORMAT,
        formatVersion: FORMAT_VERSION,
        exportedAt: new Date().toISOString(),
        app: { name: 'Filoteca', version: appVersion, flavor: STANDALONE ? 'local' : 'web', platform: device.platformLabel(), tv: !!device.isTV, lang: i18n.lang },
        settings: current,
        defaults,
        filters: perUser('filters'),
        order: perUser('customOrder'),
        notExported: skipped
    };
}

export const configFileName = (d = new Date()) => 'filoteca-config-' + d.toISOString().slice(0, 10) + '.json';
